import { render, staticRenderFns } from "./ContactTypeInfoCard.vue?vue&type=template&id=5880e74a"
import script from "./ContactTypeInfoCard.vue?vue&type=script&lang=ts"
export * from "./ContactTypeInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports